import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=f273498c&scoped=true&"
import script from "./AppDrawer.vue?vue&type=script&lang=js&"
export * from "./AppDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=f273498c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f273498c",
  null
  
)

export default component.exports